
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M11.01 3.3c3.43 0 6.2 2.77 6.2 6.2 0 1.34-.45 2.57-1.18 3.6l-.15.21.18.18L21.57 19l-1.06 1.06-5.7-5.69-.2.15a6.085 6.085 0 01-3.6 1.18c-1.22 0-2.32-.39-3.28-1l1.04-1.04c.67.37 1.41.64 2.23.64a4.801 4.801 0 000-9.6c-2.48 0-4.5 1.89-4.75 4.31l-.09.84 1.63-1.64 1 1-3.28 3.29-3.29-3.29 1-1L4.79 9.8l.04-.67a6.185 6.185 0 016.18-5.83z"}})])
          )
        }
      }
    